import { createSlice } from "@reduxjs/toolkit";

export const loanDetailSlice = createSlice({
  name: "loanDetail",
  initialState: {
    ornamentDetail: {},
    applicantLoanDetail: {},
    sameAddress : false,
    schemeChannel : [],
  },
  reducers: {
    saveLoanDetails: (state, action) => {
      state.ornamentDetail = action.payload;
    },
    saveLoanApplicantDetails: (state, action) => {
      state.applicantLoanDetail = action.payload;
    },
    saveSameAdress: (state, action) => {
      state.sameAddress = action.payload;
    },
    saveSchemeChannel: (state, action) => {
      state.schemeChannel = action.payload;
    },
  },
});

export const { saveLoanDetails, saveLoanApplicantDetails, saveSameAdress, saveSchemeChannel } = loanDetailSlice.actions;

export default loanDetailSlice.reducer;